import { atom } from 'recoil';

const tokenAtom = atom({
  key: 'tokenState',
  default: ''
});

export default tokenAtom;
